import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams, NavLink, useNavigate } from "react-router-dom";
import Select from "react-select";
import { Container, Row, Col, Form, Button, Card, CardBody, Collapse, Modal, Badge } from "react-bootstrap";
import { NumericFormat } from "react-number-format";
import { Stack } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import DataTableLayout from "layouts/DatatableLayout";
import DatatableLayoutPagination from "layouts/DatatableLayoutPagination";
import DownloadExcelLoading from "utils/DownloadExcelLoading";
import moment from "moment";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { defaultOption } from "constants/ui/options";
import { getPrefixName } from "utils/HelperFunction";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Avatar from "@mui/material/Avatar";
import InfoIcon from "@mui/icons-material/Info";
import { getAllDataContract } from "../../redux/handlers/contract/getAllDataContract.handler";
import { getAllDataContractExcel, clearGetAllDataContractExcel } from "../../redux/handlers/contract/getAllDataContractExcel.handler";
import { updateContractDel, clearUpdateContractDel } from "../../redux/handlers/contract/updateContractDel.handler";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
import { contractNewtData } from "mocks/contractData";
export function ContractNew() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), tableData = _useState[0], setTableData = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), excelTotal = _useState1[0], setExcelTotal = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), excelLoaded = _useState2[0], setExcelLoaded = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), excelLoadData = _useState3[0], setExcelLoadData = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), excelData = _useState4[0], setExcelData = _useState4[1];
    var _useState5 = _sliced_to_array(useState(1), 2), tabMenuTb = _useState5[0], setTabMenuTb = _useState5[1];
    var _useState6 = _sliced_to_array(useState(0), 2), statusContract = _useState6[0], setStatusContract = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), filteredItems = _useState7[0], setFilteredItems = _useState7[1];
    var _useState8 = _sliced_to_array(useState(""), 2), filterText = _useState8[0], setFilterText = _useState8[1];
    var _useState9 = _sliced_to_array(useState(false), 2), loadData = _useState9[0], setLoadData = _useState9[1];
    var _useState10 = _sliced_to_array(useState(0), 2), rowCtId = _useState10[0], setRowCtId = _useState10[1];
    var _useState11 = _sliced_to_array(useState(""), 2), rowCtCode = _useState11[0], setRowCtCode = _useState11[1];
    var _useState12 = _sliced_to_array(useState(false), 2), reData = _useState12[0], setReData = _useState12[1];
    var _useState13 = _sliced_to_array(useState(0), 2), statusCt = _useState13[0], setStatusCt = _useState13[1];
    var _useState14 = _sliced_to_array(useState(1), 2), pageId = _useState14[0], setPageId = _useState14[1];
    var _useState15 = _sliced_to_array(useState(10), 2), pageSize = _useState15[0], setPageSize = _useState15[1];
    var _useState16 = _sliced_to_array(useState([]), 2), sortModel = _useState16[0], setSortModel = _useState16[1];
    var _useState17 = _sliced_to_array(useState(false), 2), loading = _useState17[0], setLoading = _useState17[1];
    var _useState18 = _sliced_to_array(useState(0), 2), totalPage = _useState18[0], setTotalPage = _useState18[1];
    var _useState19 = _sliced_to_array(useState(0), 2), totalAmount = _useState19[0], setTotalAmount = _useState19[1];
    var _useState20 = _sliced_to_array(useState(""), 2), sDate = _useState20[0], setSDate = _useState20[1];
    var _useState21 = _sliced_to_array(useState(""), 2), eDate = _useState21[0], setEDate = _useState21[1];
    var _useState22 = _sliced_to_array(useState(""), 2), sDateContract = _useState22[0], setsDateContract = _useState22[1];
    var _useState23 = _sliced_to_array(useState(""), 2), eDateContract = _useState23[0], seteDateContract = _useState23[1];
    var _useState24 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalsuccess = _useState24[0], setModalsuccess = _useState24[1];
    var _useState25 = _sliced_to_array(useState(false), 2), delCtShow = _useState25[0], setDelCtShow = _useState25[1];
    var handleDelCtShowShow = function() {
        return setDelCtShow(true);
    };
    var handleDelCtClose = function() {
        return setDelCtShow(false);
    };
    var getAllDataContractReducer = useAppSelector(function(state) {
        return state.getAllDataContractReducer;
    });
    var getAllDataContractExcelReducer = useAppSelector(function(state) {
        return state.getAllDataContractExcelReducer;
    });
    var handleSearchList = function() {
        var statusList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, filterText = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        setIsLoading(true);
        dispatch(getAllDataContract({
            pageId: pageId,
            pageSize: pageSize,
            status: statusList && statusList > 0 ? parseInt(statusList, 10) : 0,
            contractcode: filterText && filterText != null && filterText != "" ? filterText : ""
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        setStatusCt(statusList);
    };
    var handleDeleteRow = function() {
        var rowId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", rowCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        if (rowId && rowId != "" && rowId != null) {
            setRowCtId(rowId);
            setRowCtCode(rowCode);
            handleDelCtShowShow();
        }
    };
    useEffect(function() {
        var data = _object_spread({
            pageId: pageId,
            pageSize: pageSize
        }, statusContract && {
            status: parseInt(statusContract)
        }, filterText && {
            contractcode: filterText
        }, sortModel && {
            sortField: sortModel.sortField,
            sortValue: sortModel.sortValue
        }, sDate && {
            sDate: moment(sDate).format("YYYY-MM-DD")
        }, eDate && {
            eDate: moment(eDate).format("YYYY-MM-DD")
        }, sDateContract && {
            sDateContract: moment(sDateContract).format("YYYY-MM-DD")
        }, eDateContract && {
            eDateContract: moment(eDateContract).format("YYYY-MM-DD")
        });
        dispatch(getAllDataContract(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        pageId,
        pageSize,
        sortModel,
        filterText,
        statusContract,
        sDate,
        eDate
    ]);
    var getData = function() {
        dispatch(getAllDataContract({
            pageId: pageId,
            pageSize: pageSize,
            status: 0,
            contractcode: ""
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var columns = [
        {
            id: "ct_contract_code",
            name: "หมายเลขสัญญา",
            sortable: true,
            sortField: "ct_contract_code",
            selector: function(row) {
                return row.ct_contract_code;
            },
            width: "170px",
            center: "true",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/manage_contract/new/edit/" + row.ct_contract_id,
                        children: row.ct_contract_code ? row.ct_contract_code : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            name: "ชื่อกิจการ",
            selector: function(row) {
                return row.ct_contract_name;
            },
            sortable: true,
            sortField: "ct_contract_name",
            cell: function(row, index, column, id) {
                return row.ct_contract_businesstype == 2 ? /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.ct_contract_name && row.ct_contract_name != "" && row.ct_contract_name != null ? row.ct_contract_comprefixname + row.ct_contract_name + row.ct_contract_suffixname : "-",
                        /*#__PURE__*/ _jsx("br", {}),
                        /*#__PURE__*/ _jsx("span", {
                            className: "figure-caption",
                            children: row.ct_contract_taxid
                        })
                    ]
                }) : row.ct_contract_businesstype == 1 ? /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.ct_contract_fname && row.ct_contract_fname != "" && row.ct_contract_fname != null ? getPrefixName(row.ct_contract_prefixid) + row.ct_contract_fname + " " + row.ct_contract_lname : "-",
                        /*#__PURE__*/ _jsx("br", {}),
                        /*#__PURE__*/ _jsx("span", {
                            className: "figure-caption",
                            children: row.ct_contract_taxid
                        })
                    ]
                }) : /*#__PURE__*/ _jsx(_Fragment, {
                    children: "-"
                });
            },
            width: "200px"
        },
        {
            name: "รายการสินค้า",
            selector: function(row) {
                return row.ct_contract_products;
            },
            cell: function(row) {
                return row.ct_contract_products.length > 0 ? row.ct_contract_products.length : "0";
            },
            center: "true",
            width: "170px",
            sortable: true,
            sortField: "ct_contract_products"
        },
        {
            name: "มูลค่าสัญญา",
            selector: function(row) {
                return row.ct_contract_total_net > 0 ? row.ct_contract_total_net : "0.00";
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsx(NumericFormat, {
                    value: row.ct_contract_total_net,
                    thousandSeparator: ",",
                    decimalScale: 2,
                    fixedDecimalScale: true,
                    displayType: "text"
                });
            },
            center: "true",
            width: "170px",
            sortable: true,
            sortField: "ct_contract_total_net"
        },
        {
            name: "วันที่สร้างสัญญา",
            selector: function(row) {
                return row.ct_contract_credate;
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.ct_contract_credate && row.ct_contract_credate != "" && row.ct_contract_credate != null ? moment(row.ct_contract_credate).format("DD/MM/YYYY") : "-"
                });
            },
            center: "true",
            width: "200px",
            sortable: true,
            sortField: "ct_contract_credate"
        },
        {
            name: "วันที่ทำสัญญา",
            selector: function(row) {
                return row.ct_contract_startdate;
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.ct_contract_startdate && row.ct_contract_startdate != "" && row.ct_contract_startdate != null ? moment(row.ct_contract_startdate).format("DD/MM/YYYY") : "-"
                });
            },
            center: "true",
            width: "200px",
            sortable: true,
            sortField: "ct_contract_startdate"
        },
        {
            name: "วันที่หมดอายุ",
            selector: function(row) {
                return row.ct_contract_enddate;
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.ct_contract_enddate && row.ct_contract_enddate != "" && row.ct_contract_enddate != null ? moment(row.ct_contract_enddate).format("DD/MM/YYYY") : "-"
                });
            },
            center: "true",
            width: "200px",
            sortable: true,
            sortField: "ct_contract_enddate"
        },
        {
            name: "อายุคงเหลือ (เดือน)",
            selector: function(row) {
                return row.PdProduct.ct_contract_enddate;
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.ct_contract_enddate && row.ct_contract_enddate != "" && row.ct_contract_enddate != null ? moment(row.ct_contract_enddate).diff(moment(), "months", true).toFixed(0) : "-"
                });
            },
            center: "true",
            sortable: true,
            width: "200px",
            sortField: "ct_contract_enddate"
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.ct_contract_status;
            },
            center: "true",
            width: "130px",
            sortable: true,
            sortField: "ct_contract_status",
            cell: function(row) {
                return row.ct_contract_status == 8 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(211, 47, 47, 1)",
                        backgroundColor: "rgba(253, 237, 237, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: row.ct_contract_status_text
                }) : row.ct_contract_status == 7 ? /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "py-1 px-2 text-center mx-auto",
                            style: {
                                color: "#6f42c1",
                                backgroundColor: "#e2d9f3",
                                borderRadius: "20px",
                                width: "130px"
                            },
                            children: row.ct_contract_status_text
                        })
                    })
                }) : row.ct_contract_status == 6 ? /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "py-1 px-2 text-center mx-auto",
                            style: {
                                color: "rgba(255, 255, 255, 1)",
                                backgroundColor: "rgba(16, 176, 42, 1)",
                                borderRadius: "20px",
                                width: "130px"
                            },
                            children: row.ct_contract_status_text
                        })
                    })
                }) : row.ct_contract_status == 5 ? /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "py-1 px-2 text-center mx-auto",
                            style: {
                                color: "rgba(211, 47, 47, 1)",
                                backgroundColor: "rgba(253, 237, 237, 1)",
                                borderRadius: "20px",
                                width: "130px"
                            },
                            children: row.ct_contract_status_text
                        })
                    })
                }) : row.ct_contract_status == 4 ? /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "py-1 px-2 text-center mx-auto",
                            style: {
                                color: "rgba(211, 47, 47, 1)",
                                backgroundColor: "rgba(253, 237, 237, 1)",
                                borderRadius: "20px",
                                width: "130px"
                            },
                            children: row.ct_contract_status_text
                        })
                    })
                }) : row.ct_contract_status == 3 ? /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "py-1 px-2 text-center mx-auto",
                            style: {
                                color: "rgba(255, 255, 255, 1)",
                                backgroundColor: "rgba(16, 176, 42, 1)",
                                borderRadius: "20px",
                                width: "130px"
                            },
                            children: row.ct_contract_status_text
                        })
                    })
                }) : row.ct_contract_status == 2 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(253, 180, 40, 1)",
                        backgroundColor: "rgba(255, 246, 229, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: row.ct_contract_status_text
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(116, 116, 116, 1)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "90px"
                    },
                    children: row.ct_contract_status_text
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.ct_contract_id;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(Stack, {
                    direction: "horizontal",
                    gap: 2,
                    sx: {
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: row.ct_contract_id && row.ct_contract_status < 2 ? /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "link",
                            className: "m-0 py-0",
                            onClick: function() {
                                return handleDeleteRow(row.ct_contract_id, row.ct_contract_code);
                            },
                            children: /*#__PURE__*/ _jsx(Avatar, {
                                sx: {
                                    color: "rgba(176,4,18,1)",
                                    bgcolor: "rgba(246,225,227,1)",
                                    fontSize: 30
                                },
                                children: /*#__PURE__*/ _jsx(DeleteIcon, {
                                    fontSize: "inherit"
                                })
                            })
                        })
                    }) : "-"
                });
            },
            center: "true"
        }
    ];
    // useEffect(() => {
    //   getData();
    // }, []);
    useEffect(function() {
        if (reData) {
            setReData(false);
            getData();
        }
        if (statusCt && statusCt > 0) {
            handleSearchList(statusCt, filterText);
        }
    }, [
        reData,
        statusCt
    ]);
    var handleChangePage = function(newPage) {
        setPageId(newPage);
    };
    var handleChangeRowsPerPage = function(newPageSize) {
        setPageSize(newPageSize);
    };
    var handleSort = function(column, sortDirection) {
        var field = column === null || column === void 0 ? void 0 : column.sortField;
        var value = sortDirection; // 'asc' หรือ 'desc'
        console.log("Sort:", {
            sortField: field,
            sortValue: value
        });
        setSortModel({
            sortField: field,
            sortValue: value
        });
    };
    useEffect(function() {
        setIsLoading(getAllDataContractReducer.isFetching);
        if (getAllDataContractReducer.data && !getAllDataContractReducer.isError) {
            var _getAllDataContractReducer_data_data, _getAllDataContractReducer_data;
            var data = getAllDataContractReducer.data.data;
            var pagination = getAllDataContractReducer === null || getAllDataContractReducer === void 0 ? void 0 : (_getAllDataContractReducer_data = getAllDataContractReducer.data) === null || _getAllDataContractReducer_data === void 0 ? void 0 : (_getAllDataContractReducer_data_data = _getAllDataContractReducer_data.data) === null || _getAllDataContractReducer_data_data === void 0 ? void 0 : _getAllDataContractReducer_data_data.pagination;
            setTableData(data.data);
            setTotalPage((pagination === null || pagination === void 0 ? void 0 : pagination.totalPage) || 0);
            setTotalAmount((pagination === null || pagination === void 0 ? void 0 : pagination.total) || 0);
            setExcelData([]);
            setExcelTotal((pagination === null || pagination === void 0 ? void 0 : pagination.total) || 0);
            setExcelLoaded(true);
            dispatch(clearGetAllDataContractExcel());
        }
    }, [
        getAllDataContractReducer
    ]);
    useEffect(function() {
        if (excelLoaded && excelTotal) {
            setExcelLoaded(false);
            var dataExcel = _object_spread({
                pageId: 1,
                pageSize: excelTotal
            }, statusContract && {
                status: parseInt(statusContract)
            }, filterText && {
                contractcode: filterText
            }, sortModel && {
                sortField: sortModel.sortField,
                sortValue: sortModel.sortValue
            }, sDate && {
                sDate: moment(sDate).format("YYYY-MM-DD")
            }, eDate && {
                eDate: moment(eDate).format("YYYY-MM-DD")
            }, sDateContract && {
                sDateContract: moment(sDateContract).format("YYYY-MM-DD")
            }, eDateContract && {
                eDateContract: moment(eDateContract).format("YYYY-MM-DD")
            });
            dispatch(getAllDataContractExcel(dataExcel, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        excelTotal,
        excelLoaded
    ]);
    useEffect(function() {
        setExcelLoadData(getAllDataContractExcelReducer.isFetching);
        if (getAllDataContractExcelReducer.data && !getAllDataContractExcelReducer.isError) {
            var tableExcel = getAllDataContractExcelReducer.data.data;
            if (tableExcel && (tableExcel === null || tableExcel === void 0 ? void 0 : tableExcel.data.length) && (tableExcel === null || tableExcel === void 0 ? void 0 : tableExcel.data.length) > 0) {
                tableExcel === null || tableExcel === void 0 ? void 0 : tableExcel.data.map(function(item, index) {
                    if (item.ct_contract_id && item.ct_contract_id != "" && item.ct_contract_id > 0) {
                        setExcelData(function(excelData) {
                            return _to_consumable_array(excelData).concat([
                                {
                                    "ลำดับ": index + 1,
                                    "หมายเลขสัญญา": item.ct_contract_code,
                                    "ชื่อลูกค้า": item.ct_contract_businesstype == 2 ? item.ct_contract_name && item.ct_contract_name != "" && item.ct_contract_name != null ? item.ct_contract_comprefixname + item.ct_contract_name + item.ct_contract_suffixname : "-" : item.ct_contract_businesstype == 1 ? item.ct_contract_fname && item.ct_contract_fname != "" && item.ct_contract_fname != null ? getPrefixName(item.ct_contract_prefixid) + item.ct_contract_fname + " " + item.ct_contract_lname : "-" : "-",
                                    "รายการสินค้า": item.ct_contract_products && item.ct_contract_products.length > 0 ? item.ct_contract_products.length : "0",
                                    "มูลค่าสัญญา": item.ct_contract_total_net > 0 ? parseFloat(item.ct_contract_total_net).toFixed(2) : "0.00",
                                    "วันที่สร้างสัญญา": item.ct_contract_credate && item.ct_contract_credate != "" && item.ct_contract_credate != null ? moment(item.ct_contract_credate).format("DD/MM/YYYY") : "-",
                                    "วันที่ทำสัญญา": item.ct_contract_startdate && item.ct_contract_startdate != "" && item.ct_contract_startdate != null ? moment(item.ct_contract_startdate).format("DD/MM/YYYY") : "-",
                                    "วันที่หมดอายุ": item.ct_contract_enddate && item.ct_contract_enddate != "" && item.ct_contract_enddate != null ? moment(item.ct_contract_enddate).format("DD/MM/YYYY") : "-",
                                    "อายุคงเหลือ (เดือน)": item.ct_contract_enddate && item.ct_contract_enddate != "" && item.ct_contract_enddate != null ? moment(item.ct_contract_enddate).diff(moment(), "months", true).toFixed(0) : "-",
                                    "สถานะ": item.ct_contract_status_text || "-"
                                }
                            ]);
                        });
                    }
                });
            }
        }
    }, [
        getAllDataContractExcelReducer
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("nav", {
                "aria-label": "breadcrumb",
                className: "mt-2",
                children: /*#__PURE__*/ _jsxs("ol", {
                    className: "breadcrumb fs-16 ps-0 mb-1",
                    children: [
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item ",
                            children: /*#__PURE__*/ _jsx("a", {
                                href: "/manage_contract/new",
                                className: "tc-7  text-decoration-none",
                                children: "จัดการสัญญา"
                            })
                        }),
                        /*#__PURE__*/ _jsxs("li", {
                            className: "breadcrumb-item active tc-1 ",
                            "aria-current": "page",
                            children: [
                                " ",
                                "สร้างสัญญาใหม่",
                                " "
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mb-2",
                children: /*#__PURE__*/ _jsx("h3", {
                    className: "h3",
                    children: "สร้างสัญญาใหม่"
                })
            }),
            /*#__PURE__*/ _jsxs(Row, {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 4,
                        sm: 4,
                        md: "auto",
                        className: "d-grid",
                        children: /*#__PURE__*/ _jsx(Button, {
                            className: "btn-category px-2 text-decoration-none",
                            onClick: function() {
                                setTabMenuTb(1);
                                setStatusContract(0);
                                setPageId(1);
                            // handleSearchList(0, filterText);
                            },
                            variant: "",
                            active: tabMenuTb == 1 ? true : false,
                            children: "ทั้งหมด"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 4,
                        sm: 4,
                        md: "auto",
                        className: "d-grid",
                        children: /*#__PURE__*/ _jsx(Button, {
                            className: "btn-category px-2 text-decoration-none",
                            onClick: function() {
                                setTabMenuTb(2);
                                setStatusContract(1);
                                setPageId(1);
                            // handleSearchList(1, filterText);
                            },
                            variant: "",
                            active: tabMenuTb == 2 ? true : false,
                            children: "แบบร่าง"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 4,
                        sm: 4,
                        md: "auto",
                        className: "d-grid",
                        children: /*#__PURE__*/ _jsx(Button, {
                            className: "btn-category px-2 text-decoration-none",
                            onClick: function() {
                                setTabMenuTb(3);
                                setStatusContract(2);
                                setPageId(1);
                            // handleSearchList(2, filterText);
                            },
                            variant: "",
                            active: tabMenuTb == 3 ? true : false,
                            children: "รออนุมัติ"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 6,
                        sm: 4,
                        md: "auto",
                        className: "d-grid",
                        children: /*#__PURE__*/ _jsx(Button, {
                            className: "btn-category px-2 text-decoration-none",
                            onClick: function() {
                                setTabMenuTb(4);
                                setStatusContract(3);
                                setPageId(1);
                            // handleSearchList(3, filterText);
                            },
                            variant: "",
                            active: tabMenuTb == 4 ? true : false,
                            children: "อนุมัติแล้ว"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 6,
                        sm: 4,
                        md: "auto",
                        className: "d-grid",
                        children: /*#__PURE__*/ _jsx(Button, {
                            className: "btn-category px-2 text-decoration-none",
                            onClick: function() {
                                setTabMenuTb(5);
                                setStatusContract(4);
                                setPageId(1);
                            // handleSearchList(4, filterText);
                            },
                            variant: "",
                            active: tabMenuTb == 5 ? true : false,
                            children: "ไม่อนุมัติ"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 6,
                        sm: 4,
                        md: "auto",
                        className: "d-grid",
                        children: /*#__PURE__*/ _jsx(Button, {
                            className: "btn-category px-2 text-decoration-none",
                            onClick: function() {
                                setTabMenuTb(6);
                                setStatusContract(6);
                                setPageId(1);
                            // handleSearchList(6, filterText);
                            },
                            variant: "",
                            active: tabMenuTb == 6 ? true : false,
                            children: "ยืนยันสัญญา"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 6,
                        sm: 4,
                        md: "auto",
                        className: "d-grid",
                        children: /*#__PURE__*/ _jsx(Button, {
                            className: "btn-category px-2 text-decoration-none",
                            onClick: function() {
                                setTabMenuTb(7);
                                setStatusContract(7);
                                setPageId(1);
                            // handleSearchList(7, filterText);
                            },
                            variant: "",
                            active: tabMenuTb == 7 ? true : false,
                            children: "กำลังดำเนินการ"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 6,
                        sm: 4,
                        md: "auto",
                        className: "d-grid",
                        children: /*#__PURE__*/ _jsx(Button, {
                            className: "btn-category px-2 text-decoration-none",
                            onClick: function() {
                                setTabMenuTb(8);
                                setStatusContract(8);
                                setPageId(1);
                            // handleSearchList(8, filterText);
                            },
                            variant: "",
                            active: tabMenuTb == 8 ? true : false,
                            children: "หมดสัญญา"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 4,
                        sm: 4,
                        md: "auto",
                        className: "d-grid",
                        children: /*#__PURE__*/ _jsx(Button, {
                            className: "btn-category px-2 text-decoration-none",
                            onClick: function() {
                                setTabMenuTb(9);
                                setStatusContract(5);
                                setPageId(1);
                            // handleSearchList(5, filterText);
                            },
                            variant: "",
                            active: tabMenuTb == 9 ? true : false,
                            children: "ยกเลิก"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Card, {
                className: "card-st-1 mb-4",
                children: /*#__PURE__*/ _jsxs(CardBody, {
                    children: [
                        /*#__PURE__*/ _jsxs(Row, {
                            className: "align-items-center",
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 3,
                                    lg: 6,
                                    xl: 8,
                                    className: "mb-2",
                                    children: /*#__PURE__*/ _jsx(DownloadExcelLoading, {
                                        data: excelData,
                                        filename: "contract_" + moment().format("YYYYMMDDHHmmss"),
                                        loading: excelLoadData
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: true,
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4 form-200 mb-2",
                                        placeholder: "ค้นหา หมายเลขสัญญา",
                                        onKeyUp: function(e) {
                                            setFilterText(e.target.value);
                                        //handleSearchList(statusContract, e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: "auto",
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        className: "btn-st-7 bt-width-120 px-2 mb-2",
                                        href: "/manage_contract/new/create",
                                        variant: "",
                                        children: "สร้างสัญญา"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                            item: tableData,
                            columns: columns,
                            isSelectRows: false,
                            currentPage: pageId,
                            currentPageSize: pageSize,
                            onChangePage: handleChangePage,
                            onChangePageSize: handleChangeRowsPerPage,
                            totalPage: totalPage,
                            totalAmount: totalAmount,
                            sortModel: sortModel,
                            onChangeSort: setSortModel,
                            handleSort: handleSort,
                            loading: loading
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(DeleteModal, {
                show: delCtShow,
                onHide: handleDelCtClose,
                rowCtId: rowCtId,
                rowCtCode: rowCtCode,
                setReData: setReData,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess
            }),
            /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: modalsuccess.visible,
                onHide: function() {
                    return setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                textsuccess: modalsuccess.textsuccess,
                navigate: navigate,
                direction: modalsuccess.direction
            })
        ]
    });
}
function DeleteModal(_param) {
    var rowCtId = _param.rowCtId, rowCtCode = _param.rowCtCode, props = _object_without_properties(_param, [
        "rowCtId",
        "rowCtCode"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var contractID = useParams().contractID;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var updateContractDelReducer = useAppSelector(function(state) {
        return state.updateContractDelReducer;
    });
    var handleChange = function(e) {};
    var handleClick = function(val) {
        if (rowCtId && rowCtId != "" && rowCtId > 0) {
            setIsLoading(true);
            var payload = {
                contractid: parseInt(rowCtId, 10)
            };
            dispatch(updateContractDel(payload, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setIsBoxAlert(true);
            props.onHide();
        } else {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณากรอกเลือกรายการที่ต้องการลบ"
            }));
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateContractDelReducer.isFetching);
        if (rowCtId && rowCtId != "" && rowCtId != null) {
            if (updateContractDelReducer.data && !updateContractDelReducer.isError) {
                var updatedData = updateContractDelReducer.data.data;
                dispatch(clearUpdateContractDel());
            }
        }
        if (isBoxAlert) {
            props.setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "ลบรายการเลขที่สัญญา " + rowCtCode + " เรียบร้อย",
                    direction: ""
                });
            });
            setIsBoxAlert(false);
            props.setReData(true);
        }
    }, [
        updateContractDelReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "ลบรายการ"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Badge, {
                            bg: "danger-light",
                            text: "dark",
                            style: {
                                fontSize: "16px !important",
                                whiteSpace: "unset !important"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(InfoIcon, {
                                    sx: {
                                        color: "#B00412"
                                    },
                                    className: "mr-2"
                                }),
                                "คุณต้องการที่จะลบเลขที่สัญญา ",
                                rowCtCode,
                                " หรือไม่"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ตกลง"
                    })
                ]
            })
        ]
    }));
}
